import data from "./content.generated.json";

export type LandingContent = typeof data;

export function getLandingContent(): LandingContent {
  return data;
}
